import { initFontDict, initFontSizeRangeDict, setFontRecentlyUsed } from './actions';

import { createReducer } from '@reduxjs/toolkit';

// https://redux-toolkit.js.org/api/createreducer/
// Most importantly, you need to ensure that you either mutate the state argument or return a new state, but not both.

export const fontDict = createReducer({}, (builder) => {
  builder
    .addCase(initFontDict, (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        let fonts = action.payload[key];

        fonts.sort(
          (a, b) => a.fontFace.localeCompare(b.fontFace) || a.hasBold - b.hasBold || a.hasItalic - b.hasItalic
        );
        state[key] = fonts.map((font) => {
          return { ...font, recentlyUsed: false };
        });
      });
      //state = action.payload;
    })
    .addCase(setFontRecentlyUsed, (state, action) => {
      const { imprintArea, font } = action.payload;
      const fonts = state[imprintArea];

      state[imprintArea] = fonts.map((f) => (f.fontFace === font.fontFace ? { ...f, recentlyUsed: true } : f));
    });
});
export const fontSizeRangeDict = createReducer({}, (builder) => {
  builder.addCase(initFontSizeRangeDict, (state, action) => {
    Object.keys(action.payload).forEach((key) => (state[key] = action.payload[key]));
    //state = action.payload;
  });
});
